import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Component/Login";
import Register from "./Component/Register";
import User from "./Admin/Component/User";
import AdminLayout from "./Admin/AdminLayout";
import EmpTask from "./Admin/Component/EmpTask";
import { Task } from "@mui/icons-material";
import UserTask from "./Admin/Component/UserTask";
import TaskListEmp from "./Admin/Component/TaskListEmp";
import ProtectedRoute from "./ProtectedRoute"; // Import the ProtectedRoute

function App() {
  // In a real app, you would get this from your auth context or state
  const isAuthenticated = !!localStorage.getItem("token"); // Double bang to ensure boolean
  console.log({ isAuthenticated })

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Protected EmpTask route */}
        <Route
          path="/emptask"
          element={
            <ProtectedRoute isAllowed={isAuthenticated}>
              <EmpTask />
            </ProtectedRoute>
          }
        />

        {/* Admin Routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute isAllowed={isAuthenticated}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute isAllowed={isAuthenticated}>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route
              path="user"
              element={
                <ProtectedRoute isAllowed={isAuthenticated}>
                  <User />
                </ProtectedRoute>
              }
            />
            <Route
              path="user-tasks"
              element={
                <ProtectedRoute isAllowed={isAuthenticated}>
                  <UserTask />
                </ProtectedRoute>
              }
            />
            <Route
              path="task-list/:empId"
              element={
                <ProtectedRoute isAllowed={isAuthenticated}>
                  <TaskListEmp />
                </ProtectedRoute>
              }
            />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;